<template>
  <div class="block">
    
    <p>
    <canvas id="canvas" ref="canvas" style="display: block; height: 150px; width: 300px;" width="100%" height="70%" class=""></canvas>
  <p>

    <div class="row">
        <div>
          <router-link class="waves-effect waves-light btn grey left" :to="{ name: 'Records'}">Back
              <i class="material-icons right">subdirectory_arrow_left</i>
          </router-link>
        </div>
      </div>
</div>
</template>

<script>
import Chart from 'chart.js'
import moment from 'moment'
import api from '@/api'

export default {
  name: 'recordLog',
  props: ['skill'],
  data: function () {
    return {
    }
  },
  mounted () {
    var skill = this.skill
    var user = api.getCurrentUser()
    var labels = []
    var values = []
    var logs = user.athlete.recordLog[skill]

    const skillName = logs.length > 0 ? logs[0].name : undefined
    const description = logs.length > 0 ? logs[0].description : undefined
    const isTime = (logs[0].unit === 'time')

    for (var i in logs.sort((a, b) => moment(a.dt) - moment(b.dt))) {
      labels.push(moment(logs[i].dt))
      if (logs[i].unit === 'time') {
        values.push(parseInt(logs[i].valueMinutes) * 60.0 + parseInt(logs[i].valueSeconds))
      } else {
        values.push(logs[i].value)
      }
    }
    var config = {
      type: 'line',
      data: {
        labels: labels,
        datasets: [{
          label: skillName,
          backgroundColor: 'red',
          borderColor: 'red',
          fill: false,
          data: values
        }]
      },
      options: {
        title: {
          text: 'Performance history'
        },
        scales: {
          xAxes: [{
            type: 'time',
            distribution: 'linear',
            time: {
              round: 'day',
              unit: 'day',
              parser: 'll',
              tooltipFormat: 'll HH:mm'
            },
            scaleLabel: {
              display: true,
              labelString: 'Date'
            }
          }],
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: description + (isTime ? ' (in seconds)' : '')
            }
          }]
        }
      }
    }

    var ctx = this.$refs.canvas.getContext('2d')
    window.myLine = new Chart(ctx, config)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.block {
  margin-top: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/records/RecordLog.vue